var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPopover = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m8 3.06-.823.824a1.25 1.25 0 0 1-.884.366H4a.25.25 0 0 0-.25.25v8c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-8a.25.25 0 0 0-.25-.25H9.707a1.25 1.25 0 0 1-.884-.366L8 3.06zm-.884-1.237a1.25 1.25 0 0 1 1.768 0l.927.927H12c.966 0 1.75.783 1.75 1.75v8A1.75 1.75 0 0 1 12 14.25H4a1.75 1.75 0 0 1-1.75-1.75v-8c0-.967.784-1.75 1.75-1.75h2.19l.926-.927z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPopover);
export default ForwardRef;